var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "sidenav" }, [
    _c(
      "div",
      { staticClass: "ma-logo" },
      [
        _vm.showMaLogo
          ? _c("svgicon", {
              attrs: {
                name: "logoMa",
                color: "#FFFFFF",
                width: "48",
                height: "20"
              }
            })
          : _vm._e(),
        !_vm.showMaLogo
          ? _c("svgicon", {
              attrs: {
                name: "allianz",
                color: "#FFFFFF",
                width: "48",
                height: "20"
              }
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "navigation",
        class: { "has-bottom-links": _vm.isAgentRole }
      },
      [
        _c(
          "ul",
          _vm._l(_vm.items, function(item) {
            return item.is_visible
              ? _c(
                  "router-link",
                  {
                    key: item.name,
                    class: {
                      "router-link-active": _vm.setActiveLink(item.path)
                    },
                    attrs: {
                      to: { name: item.name },
                      tag: "li",
                      "data-name": item.name
                    }
                  },
                  [
                    _c("svgicon", {
                      attrs: { name: item.name, color: "#FFFFFF" }
                    }),
                    !_vm.hasFloatNav(item)
                      ? _c("span", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(item.meta.literal))
                        ])
                      : _vm._e(),
                    _vm.hasFloatNav(item)
                      ? _c(
                          "ul",
                          { staticClass: "sidenav__submenu" },
                          _vm._l(item.children, function(subitem) {
                            return _c(
                              "router-link",
                              {
                                key: subitem.name,
                                attrs: { to: { name: subitem.name }, tag: "li" }
                              },
                              [
                                _c("p", { staticClass: "text-medium black" }, [
                                  _vm._v(_vm._s(subitem.meta.literal))
                                ])
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          }),
          1
        ),
        _c("ul", { staticClass: "actions" }, [
          !_vm.isAgentRole
            ? _c(
                "li",
                [
                  _c("svgicon", {
                    attrs: { name: "ico-view-modes", color: "#FFFFFF" }
                  }),
                  _c("ul", { staticClass: "sidenav__submenu" }, [
                    _c(
                      "li",
                      {
                        class: { active: _vm.agentView === false },
                        on: {
                          click: function($event) {
                            return _vm.changeView(false)
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(_vm.$t("common.managerView")))
                        ])
                      ]
                    ),
                    _c(
                      "li",
                      {
                        class: { active: _vm.agentView === true },
                        on: {
                          click: function($event) {
                            return _vm.changeView(true)
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(_vm.$t("common.agentView")))
                        ])
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "li",
            { staticClass: "sidenav__langs" },
            [
              _c("svgicon", { attrs: { name: "ico-lang", color: "#FFFFFF" } }),
              _c(
                "ul",
                { staticClass: "sidenav__submenu" },
                _vm._l(["es", "fr", "it", "en", "de"], function(lang) {
                  return _c(
                    "li",
                    {
                      staticClass: "black",
                      class: { active: _vm.$i18n.locale === lang },
                      on: {
                        click: function($event) {
                          return _vm.setLang(lang)
                        }
                      }
                    },
                    [
                      _c("p", { staticClass: "text-medium black" }, [
                        _vm._v(_vm._s(lang))
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }